var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { APPEvent } from "@/events/AppEvents";
import { Apphandler } from "@/ipc/MainAppHandler";
import { AppState } from "@/share/AppState";
import { LetrEditrequestType, LetrRequestType } from "@/share/Letr";
import { LeterPermissionType } from "@@/Letr";
import { action, makeObservable, observable } from "mobx";
import { BaseDialogState } from "@/app/UIComponents/BaseDialog";
import { LetrUI } from "@/app/uistore/LetrUI";
import { LetrLinksDialogState } from "@/app/UIComponents/LetrLinkDialogState";
import { LetrLinkEmailDialogState } from "@/app/UIComponents/LinkEmail";
import { AddMemberDialogState } from "../uistore/AddMemberDialogState";
import { comm } from "@/Comm/comm";
import { ServerPath } from "@@/ServerPath";
export class LetrDetailsStore {
    constructor() {
        this.editwatermark = false;
        this.editingaikey = false;
        this.editaikey = "";
        this.savingwatermark = false;
        this.savingaikey = false;
        this.editablewk = "";
        this.aitext = "";
        this.activeLetrid = "";
        this.loading = false;
        this.removing = false;
        this.editmember = new Set();
        this.adding = false;
        this.allowSelEdit = false;
        this.showmenu = false;
        this.showHidden = false;
        this.selectedConnect = "";
        this.savedwatermark = "";
        this.loadingConnectsDetail = false;
        this.connectdetailerror = "";
        this.accesskey = "";
        this.connectpasswordhint = "";
        this.connectpassword = "";
        this.showhintpassword = false;
        this.updatinghintpassword = false;
        this.updatepasswordhintstage = 0;
        this.showexternal = false;
        this.showletrwing = false;
        this.showletrlinks = false;
        this.filterString = "";
        this.letrlinks = new Map();
        this.downloadinglinks = false;
        this.memebrids = new Set();
        this.editpermission = new Map();
        this.savingmems = new Set();
        this.letrdialogstate = new LetrLinksDialogState();
        this.letremaildialogstate = new LetrLinkEmailDialogState();
        this.addmemberdialogstate = new AddMemberDialogState();
        this.deletelinks = new Set();
        this.emaillinkid = "";
        this.linkemail = "";
        this.editlink = new Set();
        this.editlinkpermission = new Map();
        this.editletrnname = "";
        this.savingletrnname = false;
        this.edittingletrname = false;
        this.savinglinks = new Set();
        makeObservable(this);
        this.letrdialogstate.createlink = (name, allowedit, roleid) => {
            this.createLetrLink(name, allowedit, roleid);
        };
        this.letremaildialogstate.sendEmail = (name, email, id) => {
            this.sendLetrEmailLink(name, email, id);
        };
        APPEvent.addSubscriberForRenameLetr((res) => {
            if (res.letrid === this.activeLetrid) {
                if (res.ok) {
                    if (this.activeLetr) {
                        this.activeLetr.setSubject(res.newname);
                    }
                    this.setEditLetrName("");
                    this.setEditingLetr(false);
                }
                else {
                    APPEvent.publishApperror("Sorry, failed to rename letr. Please make sure you have right permissions to perform this action.");
                }
                this.setSavingLetrName(false);
            }
        });
        APPEvent.addSubscriberForActiveLetr((lt) => {
            this.setActiveLetrId(lt);
        });
        APPEvent.addSubscriberForAddConnectPasswordhint((add) => {
            if (this.updatinghintpassword) {
                if (add !== undefined && (add === null || add === void 0 ? void 0 : add.length) > 0) {
                    this.setUpdatePasswordHintStage(add[0].success ? 2 : 1);
                }
                else {
                    this.setUpdatePasswordHintStage(1);
                }
                this.setUpdatePasswordHintLoading(false);
            }
        });
        APPEvent.addSubscriberForAddWatermark((wk) => {
            if (this.savingwatermark && wk.letrid == this.activeLetrid) {
                if (wk.ok) {
                    this.updatewatermarkString(wk.watermark);
                    this.setEditWatermark(wk.watermark);
                    this.setEditingWatermark(false);
                }
                else {
                    APPEvent.publishApperror("Sorry, failed to update watermark");
                }
                this.setSavingWatermark(false);
            }
        });
        APPEvent.addSubscriberForLetrConnectDetails((det) => {
            if (this.loadingConnectsDetail) {
                if (det === undefined) {
                    // show error
                    this.accesskey = '';
                    this.setConnectHint('');
                    this.setConnectHintPassword('');
                    // this.setConnectDetailError("Sorry, but failed to load the details for thios connect. Please try again later");
                }
                else {
                    // lets put some details
                    this.accesskey = det.accesspassword;
                    this.setConnectHint(det.hint);
                    this.setConnectHintPassword(det.userpassword);
                }
            }
            this.setLoadingConnectDetail(false);
        });
        APPEvent.addSubscriberForDeleteLetrlink((res) => {
            if (res.letrid === this.activeLetrid && this.deletelinks.has(res.linkid)) {
                if (res.ok) {
                    this.removeLinkFromList(res.linkid);
                }
                else {
                    this.removeLinkFromDeleteList(res.linkid);
                    // lets alert this now
                    const link = this.letrlinks.get(res.linkid);
                    if (link !== undefined) {
                        APPEvent.publishApperror("Sorry, failed to delete " + link.name);
                    }
                }
            }
        });
        APPEvent.addSubscriberForGetLetrlink((links) => {
            if (links.letrid === this.activeLetrid) {
                links.links.forEach((link) => this.setLink(link));
                this.setDownloadingLinks(false);
            }
        });
        APPEvent.addSubscriberForCreateLetrlink((link) => {
            if (link !== undefined && (link === null || link === void 0 ? void 0 : link.letrid) === this.activeLetrid) {
                this.setLink(link.letrlink);
                this.letrdialogstate.setCreating(false);
                this.letrdialogstate.setOpen(false);
            }
        });
        APPEvent.addSubscriberForAppState(state => {
            if (state !== AppState.LoggedIn) {
                this.reset();
            }
        });
        APPEvent.addSubscriberForLetrsResponse((res) => {
            if (res.type === LetrRequestType.FetchDetail && res.letrdetail !== undefined &&
                res.letrid === this.activeLetrid) {
                this.setLetrDetail(res.letrdetail);
                this.setLoading(false);
            }
        });
        APPEvent.addSubscriberForLocalLetrDetail((res) => {
            if (res.type === LetrRequestType.FetchDetail && res.letrdetail !== undefined &&
                res.letrid === this.activeLetrid) {
                this.setLoading(true);
                this.setLetrDetail(res.letrdetail);
                this.setLoading(false);
            }
        });
        APPEvent.addSubscriberForLetrEdit((res) => {
            var _a, _b, _c;
            if (res.type === LetrEditrequestType.update) {
                if (!res.detail) {
                    APPEvent.publishApperror("Sorry, failed to update the role.");
                }
                else {
                    const perms = new Map();
                    res.detail.memberDetails.forEach((mem) => perms.set(mem.id, mem.roleid));
                    this.updateMemeberPerms(((_a = res.memberid) !== null && _a !== void 0 ? _a : []).map((memb) => memb.userid), perms);
                }
                for (const mem of (_b = res.memberid) !== null && _b !== void 0 ? _b : []) {
                    this.removeEditMemberSave(mem.userid);
                }
                return;
            }
            if (res.type === LetrEditrequestType.updatelink) {
                if (!res.links) {
                    APPEvent.publishApperror("Sorry, failed to update the role for links.");
                }
                else {
                    const links = res.links;
                    this.resetLink();
                    links.forEach((link) => this.setLink(link));
                }
                for (const mem of (_c = res.memberid) !== null && _c !== void 0 ? _c : []) {
                    this.removeEditLinkSave(mem.userid);
                    this.removeEditLink(mem.userid);
                }
                return;
            }
            if (res.detail !== undefined) {
                this.setLetrDetail(res.detail);
            }
            this.setAdding(false);
            this.setRemoving(false);
            this.setSelectedGroup(undefined);
            this.addmemberdialogstate.setOpen(false);
            this.addmemberdialogstate.setAdding(false);
        });
        APPEvent.addSubscriberForSendLetrlinkemail((res) => {
            if (res.letrid === this.activeLetrid && res.linkid === this.emaillinkid &&
                res.email === this.linkemail) {
                if (res.ok) {
                    this.letremaildialogstate.setCreating(false);
                    this.letremaildialogstate.setErrorMessage("Email with access link sent to " + res.name + ". Make sure to share password with " + res.name);
                }
                else {
                    this.letremaildialogstate.setCreating(false);
                    this.letremaildialogstate.setErrorMessage("Sorry, failed to send email to " + res.name);
                }
            }
        });
        this.dialogState = new BaseDialogState();
        this.dialogState.setHeaderLabel("Letr Details");
        this.dialogState.setHideFooter(true);
        this.dialogState.onClose = () => {
            this.setSelectedGroup(undefined);
            this.setShowMenu(false);
        };
    }
    updatewatermarkString(str) {
        if (this.activeLetr) {
            this.activeLetr.setWatermark(str);
        }
        this.setSavedWatermark(str);
    }
    savewatermark() {
        if (!this.editablewk || this.savingwatermark)
            return;
        this.setSavingWatermark(true);
        // lets just save this here now and we done
        const req = {
            letrid: this.activeLetrid,
            watermark: this.editablewk
        };
        Apphandler.sendMessage("addWatermark", req);
    }
    setSavingWatermark(saving) {
        this.savingwatermark = saving;
    }
    setSavingAiKey(saving) {
        this.savingaikey = saving;
    }
    setSavedWatermark(wk) {
        this.savedwatermark = wk;
    }
    async saveAiKey() {
        let req = {
            projectid: this.activeLetrid,
            id: this.activeLetrid,
            userid: '',
            webformid: '',
            aitext: this.editaikey,
            schemaid: ''
        };
        const res = await comm.post(ServerPath.addAiKey, req);
        if (res) {
            this.setSavingAiKey(false);
            return true;
        }
        return false;
    }
    setEditAiKey(wm) {
        this.editaikey = wm;
    }
    setEditingAiKey(editing) {
        this.editingaikey = editing;
    }
    setEditWatermark(wm) {
        this.editablewk = wm;
    }
    setEditingWatermark(editing) {
        this.editwatermark = editing;
    }
    setEditLetrName(wm) {
        this.editletrnname = wm;
    }
    setEditingLetr(editing) {
        this.edittingletrname = editing;
    }
    saveLetrName() {
        const req = {
            letrid: this.activeLetrid,
            newname: this.editletrnname
        };
        this.setSavingLetrName(true);
        Apphandler.sendMessage("renameletr", req);
    }
    setSavingLetrName(editing) {
        this.savingletrnname = editing;
    }
    addEditLinkPerm(mid, rid) {
        this.editlinkpermission.set(mid, rid);
    }
    removeEditLinkPerm(mid) {
        this.editpermission.delete(mid);
    }
    addEditLink(mid) {
        this.editlink.add(mid);
    }
    removeEditLink(mid) {
        this.editlink.delete(mid);
    }
    addEditLinkSave(mid) {
        this.savinglinks.add(mid);
    }
    removeEditLinkSave(mid) {
        this.savinglinks.delete(mid);
    }
    removeLinkFromDeleteList(id) {
        this.deletelinks.delete(id);
    }
    removeLinkFromList(id) {
        this.letrlinks.delete(id);
        this.removeLinkFromDeleteList(id);
    }
    addEditmemebr(mid) {
        this.editmember.add(mid);
    }
    removeEditMember(mid) {
        this.editmember.delete(mid);
    }
    addEditmemebrSave(mid) {
        this.savingmems.add(mid);
    }
    removeEditMemberSave(mid) {
        this.savingmems.delete(mid);
    }
    addEditmemebrPerm(mid, rid) {
        this.editpermission.set(mid, rid);
    }
    removeEditMemberPerm(mid) {
        this.editpermission.delete(mid);
    }
    deleteLetrLink(id) {
        var _a;
        this.deletelinks.add(id);
        const req = {
            letrid: (_a = this.activeLetrid) !== null && _a !== void 0 ? _a : '',
            linkid: id
        };
        Apphandler.sendMessage("deleteletrlink", req);
    }
    sendLetrEmailLink(name, email, id) {
        var _a;
        const req = {
            email: email,
            linkid: id,
            name: name,
            letrid: (_a = this.activeLetrid) !== null && _a !== void 0 ? _a : ''
        };
        this.emaillinkid = id;
        this.linkemail = email;
        Apphandler.sendMessage("sendlinkemail", req);
    }
    updateLetrMember(id) {
        const perm = this.editpermission.get(id);
        if (!perm || !this.activeLetr) {
            return;
        }
        this.addEditmemebrSave(id);
        const req = {
            type: LetrEditrequestType.update,
            memberid: [{ userid: id, permission: LeterPermissionType.View, roleid: perm }],
            letrid: this.activeLetr.id,
            isConnect: false
        };
        Apphandler.sendMessage("letredit", req);
    }
    updateLetrLink(id) {
        const perm = this.editlinkpermission.get(id);
        if (!perm || !this.activeLetr) {
            return;
        }
        this.addEditLinkSave(id);
        const req = {
            type: LetrEditrequestType.updatelink,
            memberid: [{ userid: id, permission: LeterPermissionType.View, roleid: perm }],
            letrid: this.activeLetr.id,
            isConnect: false
        };
        Apphandler.sendMessage("letredit", req);
    }
    createLetrLink(name, allowedit, roleid) {
        var _a;
        const req = {
            name: name,
            allowedit: allowedit,
            letrid: (_a = this.activeLetrid) !== null && _a !== void 0 ? _a : '',
            roleid: roleid
        };
        Apphandler.sendMessage("createletrlink", req);
    }
    resetLink() {
        this.letrlinks.clear();
        this.deletelinks.clear();
    }
    setLink(link) {
        this.letrlinks.set(link.id, link);
    }
    getLetrLinks() {
        var _a;
        if (this.downloadinglinks) {
            return;
        }
        this.setDownloadingLinks(true);
        const req = {
            letrid: (_a = this.activeLetrid) !== null && _a !== void 0 ? _a : ""
        };
        Apphandler.sendMessage("getletrlink", req);
    }
    setDownloadingLinks(downloading) {
        this.downloadinglinks = downloading;
    }
    setShowLetrLinks(show) {
        this.showletrlinks = show;
    }
    setShowLetrwingMembers() {
        this.setFilterString("");
        this.showletrwing = true;
        this.showexternal = false;
    }
    setFilterString(input) {
        this.filterString = input;
    }
    setShowExternalMembers() {
        this.setFilterString("");
        this.showexternal = true;
        this.showletrwing = false;
    }
    getLetrMemberName(id) {
        var _a;
        const mem = (_a = this.letrDetails) === null || _a === void 0 ? void 0 : _a.memberDetails.filter((fil) => fil.id === id);
        if (mem !== undefined && mem.length > 0) {
            return mem[0].name;
        }
        return "Member name unknown";
    }
    setShowAllItems() {
        this.setFilterString("");
        this.showexternal = false;
        this.showletrwing = false;
        this.setShowLetrLinks(false);
    }
    resetFilter() {
        this.setFilterString("");
        this.setShowAllItems();
    }
    reset() {
        this.setSavingWatermark(false);
        this.setEditWatermark("");
        this.setEditingWatermark(false);
        this.savingmems.clear();
        this.editpermission.clear();
        this.editmember.clear();
        this.dialogState.setOpen(false);
        this.setSelectedConnect("");
        this.setConnectDetailError("");
        this.setUpdatePasswordHintStage(0);
        this.letrlinks.clear();
        this.deletelinks.clear();
        this.setShowLetrLinks(false);
        this.memebrids = new Set();
    }
    toggleMenu() {
        this.setShowMenu(!this.showmenu);
    }
    updateHintPassword() {
        var _a;
        if (this.connectpassword.length >= 8) {
            this.setUpdatePasswordHintLoading(true);
            const req = [];
            req.push({
                letrid: (_a = this.activeLetrid) !== null && _a !== void 0 ? _a : "",
                connectpassword: {
                    hint: this.connectpasswordhint,
                    password: this.connectpassword,
                    id: this.selectedConnect
                }
            });
            Apphandler.sendMessage("createpasswordhints", req);
        }
    }
    setUpdatePasswordHintStage(stage) {
        this.updatepasswordhintstage = stage;
    }
    setUpdatePasswordHintLoading(load) {
        this.updatinghintpassword = load;
    }
    setShowHintPassword(show) {
        this.showhintpassword = show;
    }
    setConnectHint(hint) {
        this.connectpasswordhint = hint;
    }
    setConnectHintPassword(pwd) {
        this.connectpassword = pwd;
    }
    setConnectDetailError(err) {
        this.connectdetailerror = err;
    }
    setLoadingConnectDetail(loading) {
        this.loadingConnectsDetail = loading;
    }
    loadConnectDetail() {
        var _a;
        this.setConnectDetailError("");
        this.setLoadingConnectDetail(true);
        // now lets load the connect details first and then display it all 
        const req = {
            letrid: (_a = this.activeLetrid) !== null && _a !== void 0 ? _a : "",
            connectid: this.selectedConnect
        };
        Apphandler.sendMessage("fetchletrconnectdetails", req);
    }
    setSelectedConnect(con) {
        this.selectedConnect = con;
    }
    setShowMenu(show) {
        this.showmenu = show;
    }
    setSelectedGroup(grp) {
        this.selectedGroup = grp;
        this.setShowMenu(false);
    }
    setAllowEdit(allow) {
        this.allowSelEdit = allow;
    }
    setRemoving(remov) {
        this.removing = remov;
    }
    setAdding(add) {
        this.adding = add;
    }
    updateMemeberPerms(mem, perms) {
        var _a, _b, _c;
        for (const member of (_b = (_a = this.letrDetails) === null || _a === void 0 ? void 0 : _a.memberDetails) !== null && _b !== void 0 ? _b : []) {
            if (mem.indexOf(member.id) !== -1 && perms.has(member.id)) {
                member.roleid = (_c = perms.get(member.id)) !== null && _c !== void 0 ? _c : '';
            }
        }
    }
    setLetrDetail(letrDetail) {
        var _a, _b, _c, _d, _e, _f;
        this.letrDetails = letrDetail;
        this.showHidden = letrDetail.memberDetails.filter(m => m.isHidden).length > 0;
        letrDetail.memberDetails.forEach((m) => this.memebrids.add(m.id));
        console.log('letrDetail.letrWatermark?.wkstr');
        console.log((_a = letrDetail.letrWatermark) === null || _a === void 0 ? void 0 : _a.wkstr);
        (_b = this.activeLetr) === null || _b === void 0 ? void 0 : _b.setWatermark((_d = (_c = letrDetail.letrWatermark) === null || _c === void 0 ? void 0 : _c.wkstr) !== null && _d !== void 0 ? _d : '');
        console.log(this.activeLetr);
        this.setSavedWatermark((_f = (_e = letrDetail.letrWatermark) === null || _e === void 0 ? void 0 : _e.wkstr) !== null && _f !== void 0 ? _f : '');
    }
    setLoading(loading) {
        this.loading = loading;
    }
    setActiveLetrId(id) {
        if (this.activeLetrid === id) {
            return;
        }
        this.reset();
        this.activeLetrid = id;
        if (id) {
            // this.loadLetr();
        }
    }
    setActiveLetr(letr) {
        var _a, _b, _c, _d;
        this.activeLetr = letr;
        (_a = this.activeLetr) === null || _a === void 0 ? void 0 : _a.setWatermark((_d = (_c = (_b = this.letrDetails) === null || _b === void 0 ? void 0 : _b.letrWatermark) === null || _c === void 0 ? void 0 : _c.wkstr) !== null && _d !== void 0 ? _d : '');
    }
    loadLetr() {
        if (!this.activeLetrid) {
            return;
        }
        this.setLoading(true);
        const req = {
            type: LetrRequestType.FetchDetail,
            letrid: this.activeLetrid
        };
        Apphandler.sendMessage("letrs", req);
    }
    scrollTheDialogToBottom() {
        setTimeout(() => {
            var _a, _b, _c;
            return (_a = this.dialogState.dialogref.current) === null || _a === void 0 ? void 0 : _a.scrollTo({
                top: (_c = (_b = this.dialogState.dialogref.current) === null || _b === void 0 ? void 0 : _b.scrollHeight) !== null && _c !== void 0 ? _c : 1000
            });
        }, 10);
    }
    removeConnect(id) {
        if (this.removing || !this.activeLetr || this.adding) {
            return;
        }
        this.scrollTheDialogToBottom();
        this.setRemoving(true);
        if (this.selectedConnect === id) {
            this.setSelectedConnect("");
        }
        const req = {
            type: LetrEditrequestType.Delete,
            memberid: [{ userid: id, permission: LeterPermissionType.Edit, roleid: '' }],
            letrid: this.activeLetr.id,
            isConnect: true
        };
        Apphandler.sendMessage("letredit", req);
    }
    removeMember(id) {
        if (this.removing || !this.activeLetr || this.adding) {
            return;
        }
        this.scrollTheDialogToBottom();
        this.setRemoving(true);
        const req = {
            type: LetrEditrequestType.Delete,
            memberid: [{ userid: id, permission: LeterPermissionType.Edit, roleid: '' }],
            letrid: this.activeLetr.id,
            isConnect: false
        };
        Apphandler.sendMessage("letredit", req);
    }
    addMember(id) {
        if (this.removing || !this.activeLetr || this.adding) {
            return;
        }
        this.addmemberdialogstate.setAdding(true);
        this.setAdding(true);
        const req = {
            type: LetrEditrequestType.Add,
            memberid: id,
            letrid: this.activeLetr.id,
            isConnect: false
        };
        Apphandler.sendMessage("letredit", req);
    }
}
__decorate([
    observable,
    __metadata("design:type", LetrUI)
], LetrDetailsStore.prototype, "activeLetr", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], LetrDetailsStore.prototype, "editwatermark", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], LetrDetailsStore.prototype, "editingaikey", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], LetrDetailsStore.prototype, "editaikey", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], LetrDetailsStore.prototype, "savingwatermark", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], LetrDetailsStore.prototype, "savingaikey", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], LetrDetailsStore.prototype, "editablewk", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], LetrDetailsStore.prototype, "aitext", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], LetrDetailsStore.prototype, "activeLetrid", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], LetrDetailsStore.prototype, "letrDetails", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], LetrDetailsStore.prototype, "loading", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], LetrDetailsStore.prototype, "removing", void 0);
__decorate([
    observable,
    __metadata("design:type", Set)
], LetrDetailsStore.prototype, "editmember", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], LetrDetailsStore.prototype, "adding", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], LetrDetailsStore.prototype, "selectedGroup", void 0);
__decorate([
    observable,
    __metadata("design:type", Boolean)
], LetrDetailsStore.prototype, "allowSelEdit", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], LetrDetailsStore.prototype, "showmenu", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], LetrDetailsStore.prototype, "showHidden", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], LetrDetailsStore.prototype, "selectedConnect", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], LetrDetailsStore.prototype, "savedwatermark", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], LetrDetailsStore.prototype, "loadingConnectsDetail", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], LetrDetailsStore.prototype, "connectdetailerror", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], LetrDetailsStore.prototype, "connectpasswordhint", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], LetrDetailsStore.prototype, "connectpassword", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], LetrDetailsStore.prototype, "showhintpassword", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], LetrDetailsStore.prototype, "updatinghintpassword", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], LetrDetailsStore.prototype, "updatepasswordhintstage", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], LetrDetailsStore.prototype, "showexternal", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], LetrDetailsStore.prototype, "showletrwing", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], LetrDetailsStore.prototype, "showletrlinks", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], LetrDetailsStore.prototype, "filterString", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], LetrDetailsStore.prototype, "letrlinks", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], LetrDetailsStore.prototype, "downloadinglinks", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], LetrDetailsStore.prototype, "editpermission", void 0);
__decorate([
    observable,
    __metadata("design:type", Set)
], LetrDetailsStore.prototype, "savingmems", void 0);
__decorate([
    observable,
    __metadata("design:type", Set)
], LetrDetailsStore.prototype, "deletelinks", void 0);
__decorate([
    observable,
    __metadata("design:type", Set)
], LetrDetailsStore.prototype, "editlink", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], LetrDetailsStore.prototype, "editlinkpermission", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], LetrDetailsStore.prototype, "editletrnname", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], LetrDetailsStore.prototype, "savingletrnname", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], LetrDetailsStore.prototype, "edittingletrname", void 0);
__decorate([
    observable,
    __metadata("design:type", Set)
], LetrDetailsStore.prototype, "savinglinks", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], LetrDetailsStore.prototype, "updatewatermarkString", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], LetrDetailsStore.prototype, "setSavingWatermark", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], LetrDetailsStore.prototype, "setSavingAiKey", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], LetrDetailsStore.prototype, "setSavedWatermark", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], LetrDetailsStore.prototype, "setEditAiKey", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], LetrDetailsStore.prototype, "setEditingAiKey", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], LetrDetailsStore.prototype, "setEditWatermark", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], LetrDetailsStore.prototype, "setEditingWatermark", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], LetrDetailsStore.prototype, "setEditLetrName", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], LetrDetailsStore.prototype, "setEditingLetr", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], LetrDetailsStore.prototype, "setSavingLetrName", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, String]),
    __metadata("design:returntype", void 0)
], LetrDetailsStore.prototype, "addEditLinkPerm", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], LetrDetailsStore.prototype, "removeEditLinkPerm", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], LetrDetailsStore.prototype, "addEditLink", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], LetrDetailsStore.prototype, "removeEditLink", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], LetrDetailsStore.prototype, "addEditLinkSave", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], LetrDetailsStore.prototype, "removeEditLinkSave", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], LetrDetailsStore.prototype, "removeLinkFromDeleteList", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], LetrDetailsStore.prototype, "removeLinkFromList", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], LetrDetailsStore.prototype, "addEditmemebr", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], LetrDetailsStore.prototype, "removeEditMember", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], LetrDetailsStore.prototype, "addEditmemebrSave", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], LetrDetailsStore.prototype, "removeEditMemberSave", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, String]),
    __metadata("design:returntype", void 0)
], LetrDetailsStore.prototype, "addEditmemebrPerm", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], LetrDetailsStore.prototype, "removeEditMemberPerm", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], LetrDetailsStore.prototype, "deleteLetrLink", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], LetrDetailsStore.prototype, "resetLink", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], LetrDetailsStore.prototype, "setLink", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], LetrDetailsStore.prototype, "setDownloadingLinks", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], LetrDetailsStore.prototype, "setShowLetrLinks", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], LetrDetailsStore.prototype, "setShowLetrwingMembers", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], LetrDetailsStore.prototype, "setFilterString", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], LetrDetailsStore.prototype, "setShowExternalMembers", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], LetrDetailsStore.prototype, "setShowAllItems", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], LetrDetailsStore.prototype, "resetFilter", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], LetrDetailsStore.prototype, "reset", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], LetrDetailsStore.prototype, "setUpdatePasswordHintStage", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], LetrDetailsStore.prototype, "setUpdatePasswordHintLoading", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], LetrDetailsStore.prototype, "setShowHintPassword", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], LetrDetailsStore.prototype, "setConnectHint", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], LetrDetailsStore.prototype, "setConnectHintPassword", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], LetrDetailsStore.prototype, "setConnectDetailError", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], LetrDetailsStore.prototype, "setLoadingConnectDetail", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], LetrDetailsStore.prototype, "setSelectedConnect", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], LetrDetailsStore.prototype, "setShowMenu", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], LetrDetailsStore.prototype, "setSelectedGroup", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], LetrDetailsStore.prototype, "setAllowEdit", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], LetrDetailsStore.prototype, "setRemoving", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], LetrDetailsStore.prototype, "setAdding", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array, Map]),
    __metadata("design:returntype", void 0)
], LetrDetailsStore.prototype, "updateMemeberPerms", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], LetrDetailsStore.prototype, "setLetrDetail", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], LetrDetailsStore.prototype, "setLoading", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], LetrDetailsStore.prototype, "setActiveLetrId", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [LetrUI]),
    __metadata("design:returntype", void 0)
], LetrDetailsStore.prototype, "setActiveLetr", null);
